import { microsoftConstants } from '../../constant';

const initialState = {
  emailThreadsData: [],
  is_microsoft_connected: false,
};

export const check_microsoft_auth_reducer = (state = initialState, action) => {
  switch (action.type) {
    case microsoftConstants.CHECK_MICROSOFT_AUTH_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case microsoftConstants.CHECK_MICROSOFT_AUTH_SUCCESS:
      return {
        type: 'alert-success',
        is_microsoft_connected: action.payload,
      };
    case microsoftConstants.CHECK_MICROSOFT_AUTH_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};

export const fetch_microsoft_email_threads_reducer = (state = initialState, action) => {
  switch (action.type) {
    case microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_SUCCESS:
      return {
        type: 'alert-success',
        emailThreadsData: action.payload,
      };
    case microsoftConstants.FETCH_MICROSOFT_EMAIL_THREADS_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};
